import { render } from "./TalkInfo.vue?vue&type=template&id=60f11acb&scoped=true"
import script from "./TalkInfo.vue?vue&type=script&lang=js"
export * from "./TalkInfo.vue?vue&type=script&lang=js"

import "./TalkInfo.vue?vue&type=style&index=0&id=60f11acb&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f11acb"]])

export default __exports__